// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"header_wrapper_QjHGX","nav_item":"header_nav_item_17cfv","nav_achor":"header_nav_achor_1Sani","banner":"header_banner_2tMIu"};


//////////////////
// WEBPACK FOOTER
// ./src/docs/components/header.css
// module id = 68
// module chunks = 0